export var LEGACY_LOGIN_REDIRECT_URL = process.env.REACT_APP_LEGACY_PORTAL_URL +
    "/legacyauthentication/CreateUserSessionById?legacyUserID=";
export var LEGACY_LOGOUT_REDIRECT_URL = process.env.REACT_APP_LEGACY_PORTAL_URL +
    "/legacyauthentication/ClearUserSession";
export var LOGOUT_ADMIN_REDIRECT_URL = process.env.REACT_APP_MODERNIZATION_ADMIN_URL + "/";
export var HOME_PAGE_URL = process.env.REACT_APP_LEGACY_PORTAL_URL + "/Dashboard";
export var PROFILE_DETAILS_PAGE_URL = process.env.REACT_APP_LEGACY_PORTAL_URL + "/Profile";
export var SETTINGS_PAGE_URL = process.env.REACT_APP_LEGACY_PORTAL_URL + "/Profile";
export var HELP_PAGE_URL = process.env.REACT_APP_UMBRACO_PORTAL_URL + "/knowledge-base";
export var NOTIFICATIONS_PAGE_URL = process.env.REACT_APP_LEGACY_PORTAL_URL + "/Message";
export var TERMS_OF_USE_URL = process.env.REACT_APP_UMBRACO_PORTAL_URL + "/terms-of-use#";
export var PRIVACY_POLICY_URL = process.env.REACT_APP_UMBRACO_PORTAL_URL + "/privacy-policy#";
export var HELP_HUB_URL = process.env.REACT_APP_UMBRACO_PORTAL_URL + "/help-hub";
export var DASHBOARD_ADMIN_REDIRECT_URL = process.env.REACT_APP_MODERNIZATION_ADMIN_URL + "/dashboard";
